import React from "react";
import styled from "styled-components";

const PaginationWrapper = styled.div`
  @media screen and (max-width: 575px) {
    display: none;
  }
`;
const MobilePaginationWrapper = styled.div`
  display: none;
  .disabled {
    .page-link {
      opacity: 0;
    }
  }
  @media screen and (max-width: 575px) {
    display: flex;
  }
`;

function NoticePagination({
  prev,
  currentPage,
  getPaginationGroup,
  next,
  pages,
  nextEnd,
  prevStart,
  handleActive,
}) {
  return (
    <>
      {getPaginationGroup && (
        <PaginationWrapper>
          <nav className="pagination-area">
            <ul className="pagination justify-content-start">
              {getPaginationGroup.length > 0 && currentPage != 1 && (
                <li onClick={prevStart} className="page-item">
                  <a className="page-link">
                    <i className="fi-rs-angle-double-small-left"></i>
                  </a>
                </li>
              )}
              {getPaginationGroup.length > 0 && currentPage != 1 && (
                <li onClick={prev} className="page-item">
                  <a className="page-link">
                    <i className="fi-rs-angle-small-left"></i>
                  </a>
                </li>
              )}
              {getPaginationGroup.map((item, index) => {
                return (
                  <li
                    onClick={() => handleActive(item)}
                    key={index}
                    className={
                      currentPage == item ? "page-item active" : "page-item"
                    }
                    style={{ zIndex: 5 }}
                  >
                    <a className="page-link">{item}</a>
                  </li>
                );
              })}
              {getPaginationGroup.length > 0 && currentPage < pages && (
                <li onClick={next} className="page-item">
                  <a className="page-link">
                    <i className="fi-rs-angle-small-right"></i>
                  </a>
                </li>
              )}
              {getPaginationGroup.length > 0 && currentPage < pages && (
                <li onClick={nextEnd} className="page-item">
                  <a className="page-link">
                    <i className="fi-rs-angle-double-small-right"></i>
                  </a>
                </li>
              )}
            </ul>
          </nav>
        </PaginationWrapper>
      )}
      {getPaginationGroup && (
        <MobilePaginationWrapper>
          <nav className="pagination-area">
            <ul className="pagination justify-content-start">
              <li
                onClick={() => {
                  if (!(getPaginationGroup.length <= 0 || currentPage == 1)) {
                    prev();
                  }
                }}
                className={`page-item ${
                  (getPaginationGroup.length <= 0 || currentPage == 1) &&
                  "disabled"
                }`}
              >
                <a className="page-link">
                  <i className="fi-rs-angle-small-left"></i>
                </a>
              </li>
              <li className={"page-item active"} style={{ zIndex: 5 }}>
                <a className="page-link">{currentPage}</a>
              </li>
              <li
                onClick={() => {
                  if (
                    !(getPaginationGroup.length <= 0 || currentPage >= pages)
                  ) {
                    next();
                  }
                }}
                className={`page-item ${
                  (getPaginationGroup.length <= 0 || currentPage >= pages) &&
                  "disabled"
                }`}
              >
                <a className="page-link">
                  <i className="fi-rs-angle-small-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </MobilePaginationWrapper>
      )}
    </>
  );
}

export default NoticePagination;
